/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Service_UnavailableInputs */

const en_toast_service_unavailable = /** @type {(inputs: Toast_Service_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service unavailable`)
};

const nl_toast_service_unavailable = /** @type {(inputs: Toast_Service_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service niet beschikbaar`)
};

/**
* | output |
* | --- |
* | "Service unavailable" |
*
* @param {Toast_Service_UnavailableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_service_unavailable = /** @type {((inputs?: Toast_Service_UnavailableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Service_UnavailableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_service_unavailable(inputs)
	return en_toast_service_unavailable(inputs)
});